<template>
  <div class="page">
    <query-form />
    <search-bar :rightList="rightListMap" />
    <el-table :data="tableData" style="width: 100%" class="table" header-row-class-name="table-header">
      <el-table-column
        v-for="item of tableHead"
        :key="item.label"
        :label="item.label"
        :class-name="item.className"
        :width="item.width || 'auto'"
      >
        <template slot-scope="scope">
          <template v-if="item.prop">
            <span>{{ scope.row[item.prop] }}</span>
          </template>
          <template v-else>
            <div class="btn-container">
              <router-link
                tag="span"
                class="btn"
                :to="{ name: 'reconciliation/error/detail', params: { id: scope.row.id } }"
              >
                查看详情
              </router-link>
              <!-- <span class="btn" v-if="['待处理'].includes(scope.row.processingState)" @click="updateState(scope.row)"
                >修改状态</span
              > -->
              <!-- <span class="btn" v-if="['平台漏单'].includes(scope.row.errorType)" @click="reimburse(scope.row)"
                >申请退款</span
              > -->
            </div>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <Pagination :params="params" @changeSize="changeSize" @changePage="changePage" />
    </div>
  </div>
</template>

<script>
import { error } from '@reconciliation/static/data.js';
import { openDialog } from '@reconciliation/static/mixin.js';
import queryForm from '@reconciliation/components/query-form.vue';
import searchBar from '@reconciliation/components/search-bar.vue';
import { mapGetters, mapActions } from 'vuex';
import base from '@/api/base';
export default {
  name: 'list',
  mixins: [openDialog],
  provide() {
    return {
      submit: this.queryTableInfo,
      formList: error.query_form_list,
      searchPlaceholder: error.searchPlaceholder,
      downLoadExcel: this.downLoadExcel,
      searchList: this.getSearchList,
    };
  },
  computed: {
    ...mapGetters('error', ['tableData', 'params', 'rightListMap']),
  },
  components: {
    queryForm,
    searchBar,
  },
  data() {
    return {
      tableHead: error.tableHead,
      form: {
        startTime: null,
        endTime: null,
        result1: null,
        result2: null,
      }, //查询参数
      searchVal: null, //搜索内容
      applyCode: '',
    };
  },
  methods: {
    ...mapActions('error', ['queryErrorList']),
    // 条件查询
    queryTableInfo(form) {
      (this.form.startTime = form.datePicker.length > 0 ? form.datePicker[0].replace(/-/g, '') : null),
        (this.form.endTime = form.datePicker.length > 0 ? form.datePicker[1].replace(/-/g, '') : null),
        (this.form.result1 = form.result1 ? form.result1 : null);
      this.form.result2 = form.result2 ? form.result2 : null;
      console.log(this.form);
      this.getData();
    },
    // 搜索
    getSearchList(item) {
      this.searchVal = item ? item : null;
      this.getData();
    },
    // 获取列表数据
    getData() {
      this.queryErrorList({
        applyCode: this.applyCode,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        errorState: this.form.result1,
        number: this.searchVal,
        pageNum: this.params.pageNum,
        pageSize: this.params.pageSize,
        processingState: this.form.result2,
      });
    },
    // 修改条数
    changeSize(val) {
      this.params.pageSize = val;
      this.getData();
    },
    // 修改页数
    changePage(val) {
      this.params.pageNum = val;
      this.getData();
    },
    // 导出excel
    downLoadExcel() {
      window.location.href = `${base.baseUrl}/errorBill/exportListByQuery?startTime=${this.form.startTime}&endTime=${
        this.form.endTime
      }&applyCode=${this.applyCode}&number=${this.searchVal}&processingState=${this.form.result2}&errorState=${
        this.form.result1
      }&pageNum=${parseInt(this.params.pageNum)}&pageSize=${parseInt(this.params.pageSize)}`;
    },
  },
  created() {
    this.applyCode = JSON.parse(localStorage.getItem('checkdApply')).applyCode;
    this.getData();
  },
};
</script>

<style lang="less" scoped>
@import '~@reconciliation/static/common.less';
.btn-container {
  .flex_layout(row, space-between, flex-start);
  flex-wrap: wrap;
  color: @primary-blue;
  .btn {
    cursor: pointer;
    &:nth-child(2) {
      margin-right: 1em;
    }
    &:nth-child(3) {
      margin-top: 0.7em;
    }
  }
}
/deep/.batch {
  color: @primary-blue;
}
</style>
